import { THEME_COLORS as THEME_COLORS_MAIN } from "../../theme/colors";

export interface IThemeColorShades {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
}

declare module "@mui/material/styles" {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Palette {
        green: IThemeColorShades;
        gray: IThemeColorShades;
        pear: IThemeColorShades;
        yellow: IThemeColorShades;
        orange: IThemeColorShades;
        blush: IThemeColorShades;
        red: IThemeColorShades;
        lilac: IThemeColorShades;
        blue: IThemeColorShades;
        sky: IThemeColorShades;
        teal: IThemeColorShades;
        blackAlpha: IThemeColorShades;
        whiteAlpha: IThemeColorShades;
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface PaletteOptions {
        green?: IThemeColorShades;
        gray?: IThemeColorShades;
        pear?: IThemeColorShades;
        yellow?: IThemeColorShades;
        orange?: IThemeColorShades;
        blush?: IThemeColorShades;
        red?: IThemeColorShades;
        lilac?: IThemeColorShades;
        blue?: IThemeColorShades;
        sky?: IThemeColorShades;
        teal?: IThemeColorShades;
        blackAlpha?: IThemeColorShades;
        whiteAlpha?: IThemeColorShades;
    }
}

export const THEME_COLORS = {
    ...THEME_COLORS_MAIN,
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)",
    },
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)",
    },
};
